import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { PrivacyPolicy } from "../entity";
import { PrivacyPolicyState } from "../state/privacy-policy.state";

const initialState: PrivacyPolicyState = {
  privacyPolicies: [],
  page: 1,
  privacyPolicy: null!,
  text: "",
  pageCount: null!,
  errorMessage: null,
  privacyPolicyActionStart: false,
};

export const privacyPolicySlice = createSlice({
  name: "privacyPolicy",
  initialState,
  reducers: {
    setPrivacyPolicies: (
      state,
      action: PayloadAction<{
        privacyPolicies: PrivacyPolicy[];
        pageCount: number;
      }>,
    ) => {
      state.privacyPolicies = action.payload.privacyPolicies;
      state.pageCount = action.payload.pageCount;
      state.privacyPolicyActionStart = false;
    },
    setPrivacyPolicyPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setPrivacyPolicyText: (state, action: PayloadAction<string>) => {
      state.text = action.payload;
    },
    setPrivacyPolicyErrorMessage: (
      state,
      action: PayloadAction<string | null>,
    ) => {
      state.errorMessage = action.payload;
      state.privacyPolicyActionStart = false;
    },
    setPrivacyPolicyActionStart: (state, action: PayloadAction<boolean>) => {
      state.privacyPolicyActionStart = action.payload;
    },
    setPrivacyPolicy: (
      state,
      action: PayloadAction<{ privacyPolicy: PrivacyPolicy }>,
    ) => {
      state.privacyPolicy = action.payload.privacyPolicy;
      state.text = action.payload.privacyPolicy.text;
      state.privacyPolicyActionStart = false;
    },
    addPrivacyPolicyToPrivacyPolicies: (
      state,
      action: PayloadAction<{ privacyPolicy: PrivacyPolicy }>,
    ) => {
      state.privacyPolicies = [
        ...state.privacyPolicies,
        action.payload.privacyPolicy,
      ];
      state.errorMessage = null;
      state.privacyPolicyActionStart = false;
    },
    updatePrivacyPolicyInPrivacyPolicies: (
      state,
      action: PayloadAction<{ privacyPolicy: PrivacyPolicy }>,
    ) => {
      state.privacyPolicies = state.privacyPolicies.map((privacyPolicy) =>
        privacyPolicy.id === action.payload.privacyPolicy.id
          ? action.payload.privacyPolicy
          : privacyPolicy,
      );
      state.privacyPolicy = action.payload.privacyPolicy;
      state.text = action.payload.privacyPolicy.text;
      state.errorMessage = null;
      state.privacyPolicyActionStart = false;
    },
    resetPrivacyPolicy: (state) => {
      state.page = 1;
      state.privacyPolicy = null!;
      state.text = "";
      state.errorMessage = null;
      state.privacyPolicyActionStart = false;
    },
  },
});

export const {
  setPrivacyPolicies,
  setPrivacyPolicyPage,
  setPrivacyPolicyText,
  setPrivacyPolicyErrorMessage,
  setPrivacyPolicyActionStart,
  setPrivacyPolicy,
  addPrivacyPolicyToPrivacyPolicies,
  updatePrivacyPolicyInPrivacyPolicies,
  resetPrivacyPolicy,
} = privacyPolicySlice.actions;
